import React from "react";
import sIcon1 from "../../images/icon/ab-page-icon01.svg";
import sIcon2 from "../../images/icon/ab-page-icon02.svg";
import sIcon3 from "../../images/icon/ab-page-icon03.svg";
import sIcon4 from "../../images/icon/ab-page-icon04.svg";

const FeaturesSection = (props) => {
  return (
    <section className="fanfact pt-125 pb-125">
      <div className="container">
        <div className="ap-feature_wrap">
          <div className="row mt-none-30">
            <div className="col-lg-3 col-md-6 mt-30">
              <div
                className="ap-feature-item wow fadeInUp"
                data-wow-delay="0ms"
                data-wow-duration="600ms"
              >
                <div className="xb-item--icon">
                  <img src={sIcon1} alt="" />
                </div>
                <h4 className="xb-item--title"> Integrity</h4>
                <p className="xb-item--content">
                  Transparent communication and ethical standards.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mt-30">
              <div
                className="ap-feature-item wow fadeInUp"
                data-wow-delay="100ms"
                data-wow-duration="600ms"
              >
                <div className="xb-item--icon">
                  <img src={sIcon2} alt="" />
                </div>
                <h4 className="xb-item--title"> Innovation</h4>
                <p className="xb-item--content">
                  Staying ahead in design and technology.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mt-30">
              <div
                className="ap-feature-item wow fadeInUp"
                data-wow-delay="200ms"
                data-wow-duration="600ms"
              >
                <div className="xb-item--icon">
                  <img src={sIcon3} alt="" />
                </div>
                <h4 className="xb-item--title"> Collaboration</h4>
                <p className="xb-item--content">
                  Your input shapes every solution.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mt-30">
              <div
                className="ap-feature-item wow fadeInUp"
                data-wow-delay="300ms"
                data-wow-duration="600ms"
              >
                <div className="xb-item--icon">
                  <img src={sIcon4} alt="" />
                </div>
                <h4 className="xb-item--title"> Excellence</h4>
                <p className="xb-item--content">
                  Quality and user-centric design in every deliverable
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
